export default {"src":"/_next/static/media/WBTC.44204e8d.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};